module.exports = __webpack_public_path__ + "a855f5b7c04ddc3e7e75c8a00768ba45.pdf";